import { render, staticRenderFns } from "./NotificationGroup.vue?vue&type=template&id=497f05d3&scoped=true&"
import script from "./NotificationGroup.vue?vue&type=script&lang=js&"
export * from "./NotificationGroup.vue?vue&type=script&lang=js&"
import style0 from "./NotificationGroup.vue?vue&type=style&index=0&id=497f05d3&scoped=true&lang=scss&"
import style1 from "../style/bot-view.scss?vue&type=style&index=1&id=497f05d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f05d3",
  null
  
)

export default component.exports